// src/pages/ServiceAccountLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import ServiceAccountLedgerFilters from "./components/ServiceAccountLedgerFilters";
import ServiceAccountLedgerTable from "./components/ServiceAccountLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const ServiceAccountLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.serviceAccountLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Service Account Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Service Account Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ServiceAccountLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <ServiceAccountLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Service Account Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <ServiceAccountLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default ServiceAccountLedger;
